export function roundToNearest10(value: number): number {
  return Math.round(value / 10) * 10;
}
